import React from "react";
import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10 py-14"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-4">
              <img
                src="/brand/logo.png"
                alt="Precision Running logo"
                className="h-14 w-14 object-contain"
              />
              <div className="font-display text-4xl lg:text-5xl uppercase tracking-wide text-white">
                PRECISION<span className="text-brand-red">/</span>RUNNING
              </div>
            </div>
            <p className="mt-4 text-white/55 max-w-md text-sm leading-relaxed">
              Personalised online running coaching for athletes chasing their first 5K
              to their fastest half-marathon. Built and coached by Ashley Kempson.
            </p>
          </div>

          <div className="lg:col-span-4">
            <div className="label-eyebrow text-white/40 mb-4">Contact</div>
            <ul className="space-y-2 text-white/75 text-sm">
              <li>
                <a
                  href="mailto:ashley@precisionrunning.com.au"
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2 hover:text-brand-red"
                >
                  <Mail size={14} /> ashley@precisionrunning.com.au
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/ashleykempson"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-2 hover:text-brand-red"
                >
                  <Instagram size={14} /> @ashleykempson
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-white/40 font-mono tracking-widest uppercase">
            © {year} Precision Running · All rights reserved
          </div>
          <div className="text-xs text-white/40 font-mono tracking-widest uppercase">
            Made with discipline
          </div>
        </div>
      </div>
    </footer>
  );
}
